/* eslint no-class-assign:off */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as actions from '../actions';
import { getProject } from '../reducers';
import ContentBody from './ContentBody';
import Related from './Related';
import Loading from '../components/Loading';
import { resetFoldScrollPosition, getContentImage } from '../ui-helpers';

class Project extends Component {
  constructor() {
    super();
    this.links = null;
    this.handleRouteProgramatically = this.handleRouteProgramatically.bind(this);
  }
  componentDidMount() {
    const { edition } = this.props;
    this.links = document.querySelectorAll('.internal-link');
    if (this.links) {
      return;
    }
    this.links.forEach((link) => {
      link.addEventListener('click', this.handleRouteProgramatically);
      link.style.color = edition.background; // eslint-disable-line
    });
  }
  componentDidUpdate() { //eslint-disable-line
    resetFoldScrollPosition('.fold__col__body--project');
  }
  handleRouteProgramatically(event) { // eslint-disable-line
    const to = event.target.getAttribute('href');
    browserHistory.push(to);

    event.preventDefault();
  }
  render() {
    const { project, projectId, edition } = this.props;
    const { title, body, mainImage, subtitle } = project;
    if (!title) {
      return <Loading />;
    }
    const image = getContentImage(mainImage);
    const backgroundImage = {
      backgroundImage: `url(${image})`,
      marginBottom: '30px',
      paddingTop: '67.058823529412%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: edition.background,
    };
    const style = {
      color: edition.background,
    };

    return (
      <div className="single-page fold__col fold__col--main">
        <div className="scroll-area">
          <article className="content-col">
            <div className="content-col__inner">
              <header className="fold__col__header">
                <h1 className="fold__col__title" >{title}</h1>
              </header>
              <div className="fold__col__body fold__col__body--project">
                <div style={backgroundImage} className="field-main-image" />
                <div style={style} className="field-sub-title">{ subtitle }</div>
                <ContentBody background={edition.background} body={body} />
              </div>
            </div>
          </article>
          <Related color={edition.background} contentId={projectId} />
        </div>
      </div>
    );
  }
}

Project.propTypes = {
  projectId: PropTypes.string.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
    'main-image': PropTypes.string,
    date: PropTypes.string,
    slug: PropTypes.string,
    brief: PropTypes.string,
    thumb: PropTypes.string,
    edition: PropTypes.string,
  }),
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
};

Project.defaultProps = {
  project: {},
};

const mapStateToProps = (state, { edition, params }) => {
  const projectId = params.id;
  return {
    project: getProject(state, projectId),
    edition,
    projectId,
  };
};

Project = connect(
  mapStateToProps,
  actions,
)(Project);

export default Project;



// WEBPACK FOOTER //
// ./js/containers/Project.js